import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ConversationState {
  conversations: any[]
  currentConversation: any | null
  isLoading: boolean
  error: string | null
}

const initialState: ConversationState = {
  conversations: [],
  currentConversation: null,
  isLoading: false,
  error: null,
}

const conversationSlice = createSlice({
  name: 'conversation',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    setCurrentConversation: (state, action: PayloadAction<any | null>) => {
      state.currentConversation = action.payload
    },
  },
})

export const { clearError, setCurrentConversation } = conversationSlice.actions
export default conversationSlice.reducer
